import '@/instrument'

import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { createRoutesFromElements, createBrowserRouter, Route } from 'react-router'
import { RouterProvider } from 'react-router/dom'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7'
import { Theme } from '@radix-ui/themes'
import { SubscriptionRose } from '@/pages/subscription/rose/index'
import { SubscriptionRoseNew, loader as subscriptionRoseNewLoader } from '@/pages/subscription/rose/new/index'
import { SubscriptionRoseSubscribed, loader as subscriptionRoseSubscribedLoader } from '@/pages/subscription/rose/subscribed/index'
import { SubscriptionRoseLogin, loader as subscriptionRoseLoginLoader } from '@/pages/subscription/rose/login/index'
import { SubscriptionRoseMypageLayout, loader as mypageLayoutLoader } from '@/pages/subscription/rose/mypage/index'
import { SubscriptionRoseMypageTop, loader as subscriptionRoseTopLoader } from '@/pages/subscription/rose/mypage/top/index'
import { SubscriptionRoseMypageBulk, loader as subscriptionRoseBulkLoader } from '@/pages/subscription/rose/mypage/bulk/index'
import { SubscriptionRoseMypageBulkDone, loader as subscriptionRoseBulkDoneLoader } from '@/pages/subscription/rose/mypage/bulk/done/index'
import { SubscriptionRoseMypageSkip, loader as subscriptionRoseSkipLoader } from '@/pages/subscription/rose/mypage/skip/index'
import { SubscriptionRoseMypageNext, loader as subscriptionRoseNextLoader } from '@/pages/subscription/rose/mypage/next/index'
import { SubscriptionRoseMypageSchedule, loader as subscriptionRoseScheduleLoader } from '@/pages/subscription/rose/mypage/schedule/index'
import { SubscriptionRoseMypageAddress, loader as subscriptionRoseAddressLoader } from '@/pages/subscription/rose/mypage/address/index'
import { SubscriptionRoseMypageOrders, loader as subscriptionRoseOrdersLoader } from '@/pages/subscription/rose/mypage/orders/index'
import { SubscriptionRoseMypageCancel, loader as subscriptionRoseCancelLoader } from '@/pages/subscription/rose/mypage/cancel/index'
import { SubscriptionRoseMypageCard } from '@/pages/subscription/rose/mypage/card/index'
import { SubscriptionRoseMypageEmail } from '@/pages/subscription/rose/mypage/email/index'
import { SubscriptionRoseMypagePassword } from '@/pages/subscription/rose/mypage/password/index'
import { SubscriptionRoseMypageDelete, loader as subscriptionRoseDeleteLoader } from '@/pages/subscription/rose/mypage/delete/index'

import '@fontsource-variable/noto-sans-jp'
import '@fontsource-variable/inter'
import '@fontsource/dm-serif-display'
import '@radix-ui/themes/styles.css'
import '@/styles/subscription-branch.tailwind.css'

const ErrorPage = () => <></>

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" errorElement={<ErrorPage />}>
      <Route path="subscription/rose" element={<SubscriptionRose />} />
      <Route path="subscription/rose/new" element={<SubscriptionRoseNew />} loader={subscriptionRoseNewLoader} />
      <Route path="subscription/rose/subscribed" element={<SubscriptionRoseSubscribed />} loader={subscriptionRoseSubscribedLoader} />
      <Route path="subscription/rose/login" element={<SubscriptionRoseLogin />} loader={subscriptionRoseLoginLoader} />
      <Route element={<SubscriptionRoseMypageLayout />} loader={mypageLayoutLoader} id={'mypageLayout'}>
        <Route path="subscription/rose/mypage" element={<SubscriptionRoseMypageTop />} loader={subscriptionRoseTopLoader} />
        <Route path="subscription/rose/mypage/bulk" element={<SubscriptionRoseMypageBulk />} loader={subscriptionRoseBulkLoader} />
        <Route path="subscription/rose/mypage/bulk/done" element={<SubscriptionRoseMypageBulkDone />} loader={subscriptionRoseBulkDoneLoader} />
        <Route path="subscription/rose/mypage/skip" element={<SubscriptionRoseMypageSkip />} loader={subscriptionRoseSkipLoader} />
        <Route path="subscription/rose/mypage/next" element={<SubscriptionRoseMypageNext />} loader={subscriptionRoseNextLoader} />
        <Route path="subscription/rose/mypage/schedule" element={<SubscriptionRoseMypageSchedule />} loader={subscriptionRoseScheduleLoader} />
        <Route path="subscription/rose/mypage/address" element={<SubscriptionRoseMypageAddress />} loader={subscriptionRoseAddressLoader} />
        <Route path="subscription/rose/mypage/orders" element={<SubscriptionRoseMypageOrders />} loader={subscriptionRoseOrdersLoader} />
        <Route path="subscription/rose/mypage/cancel" element={<SubscriptionRoseMypageCancel />} loader={subscriptionRoseCancelLoader} />
        <Route path="subscription/rose/mypage/card" element={<SubscriptionRoseMypageCard />} />
        <Route path="subscription/rose/mypage/email" element={<SubscriptionRoseMypageEmail />} />
        <Route path="subscription/rose/mypage/password" element={<SubscriptionRoseMypagePassword />} />
        <Route path="subscription/rose/mypage/delete" element={<SubscriptionRoseMypageDelete />} loader={subscriptionRoseDeleteLoader} />
      </Route>
    </Route>,
  ),
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorPage />}>
      <NuqsAdapter>
        <Theme accentColor="orange" grayColor="sand" appearance="light">
          <RouterProvider router={router} />
        </Theme>
      </NuqsAdapter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)
